"use client";
import { css } from "styled-components";
import {
  fontSize14,
  fontSize16,
  spacing16,
  spacing8,
  spacing4,
  text120,
  sans,
  lineHeightTight,
  fontWeightNormal,
  borderRadius,
  setAppearanceConstantLocal,
  whiteTransparency30,
  whiteTransparency70,
  grey90
} from "@churchofjesuschrist/eden-style-constants";
import { adjustHexAlpha } from "@churchofjesuschrist/eden-utilities";
const paddingBlockStartEnd = spacing4;
const paddingInlineStartEnd = spacing16;
const [buttonDisabledDef, buttonDisabled] = setAppearanceConstantLocal(
  "button-disabled",
  {
    light: adjustHexAlpha(grey90, 0.38),
    dark: whiteTransparency30,
    prefix: "eden"
  }
);
const [buttonDisabledBackgroundDef, buttonDisabledBackground] = setAppearanceConstantLocal("button-disabled-background", {
  light: adjustHexAlpha(grey90, 0.12),
  dark: whiteTransparency70,
  prefix: "eden"
});
const shared = css`
  ${buttonDisabledDef};
  ${buttonDisabledBackgroundDef};
  text-transform: none;
  overflow: visible;
  display: inline-flex;
  gap: calc(${spacing8} + ${spacing4});
  align-items: center;
  justify-content: center;
  margin: 0;
  border: 0;
  border-radius: ${borderRadius};
  cursor: pointer;
  font-weight: ${fontWeightNormal};
  ${({ $fullWidth }) => $fullWidth ? "width: 100%" : "width: fit-content; max-width: 18rem"};
  vertical-align: top;
  text-decoration: none;
  padding: ${paddingBlockStartEnd} ${paddingInlineStartEnd};
  font-family: ${sans};
  line-height: ${lineHeightTight};
  color: ${text120};

  /* Assumed to be an icon: */
  & > svg {
    min-width: 1.5rem;
    min-height: 1.5rem;
    margin: 0 -${spacing8};
    flex-shrink: 0;
  }

  ${({ $small }) => $small ? `font-size: ${fontSize14};
        min-height: 2rem;
        ` : `font-size: ${fontSize16};
        min-height: 2.5rem;
        `};

  @media (any-hover: hover) {
    &:hover {
      color: ${text120};
      text-decoration: none;
    }
  }

  &[disabled],
  &[disabled]:hover {
    background-color: ${buttonDisabledBackground};
    color: ${buttonDisabled};
    border-color: ${buttonDisabledBackground};
    cursor: not-allowed;
  }
`;
var shared_default = shared;
export {
  shared_default as default,
  paddingBlockStartEnd,
  paddingInlineStartEnd
};
